export enum EChatActionTypes {
    OPEN_CHAT = '@chat/open',
    CLOSE_CHAT = '@chat/close',
    CHANGE_LOADED_CHAT = '@chat/change/loaded',
}
